// import React from "react";
// import { Route, Redirect } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isLoggedIn = localStorage.getItem("logged");
//   return isLoggedIn ? <Redirect to="/" /> : children;
// };

// export default ProtectedRoute;

import React, { useEffect, useState } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  API,
  Event
} from './utils/Helper';
import CustomLoader from './components/common/CustomLoader';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("logged");
  const location = useLocation();
  const [isAllowed, setIsAllowed] = useState(true);
  const [ageConfirmed, setAgeConfirmed] = useState(true);

  const checkUserLocation = async () => {
    try {
      const ipResponse = await fetch("https://ipinfo.io/json");
      const data = await ipResponse.json();

      const response = await fetch(`${API}/admin/checkStateIsAllowed`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          country: data.country,
          region: data.region,
          city: data.city,
          zip: data.postal,
          lat_lon: data.loc,
          timezone: data.timezone,
          isp: data.org,
        })
      });
      const responseData = await response.json();

      const response2 = await fetch(`${API}/admin/checkCountryIsAllowed`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          country: data.country,
          region: data.region,
          city: data.city,
          zip: data.postal,
          lat_lon: data.loc,
          timezone: data.timezone,
          isp: data.org,
        })
      });
      const response2Data = await response2.json();

     if (!responseData.allowed || !response2Data.allowed) {
        Swal.fire({
          title: "Access Restricted",
          text: "You are not allowed to access this site from your location.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "Go Back",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          backdrop: `rgba(0, 0, 0, 0.9)`,
        }).then(() => {
          window.location.replace("https://www.google.com");
        });

        setIsAllowed(false);
      } else {
        setIsAllowed(true);
      }
    } catch (error) {
      console.error("Error fetching location:", error);
      setIsAllowed(false);
    }
  };

  // useEffect(() => {
  //   checkUserLocation();
  // }, [location.pathname]); 

  // useEffect(() => {
  //   if (isAllowed && !ageConfirmed) {
  //     Swal.fire({
  //       title: "Are you 18 or older?",
  //       text: "You need to confirm your age to proceed.",
  //       icon: "question",
  //       showCancelButton: true,
  //       confirmButtonColor: "#28a745",
  //       cancelButtonColor: "#dc3545",
  //       confirmButtonText: "Yes, I am!",
  //       cancelButtonText: "No, Take me back",
  //       backdrop: `rgba(0, 0, 0, 0.9)`,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         localStorage.setItem("is18+", "true");
  //         setAgeConfirmed(true);
  //       } else {
  //         localStorage.setItem("is18+", "false");
  //         Swal.fire({
  //           title: "Access Denied",
  //           text: "You must be 18 or older to proceed.",
  //           icon: "error",
  //           timer: 2000,
  //           showConfirmButton: false,
  //         }).then(() => {
  //           window.location.replace("https://www.google.com");
  //         });
  //       }
  //     });
  //   }
  // }, [isAllowed, ageConfirmed]);

  // Trigger login modal for unauthenticated users
  // useEffect(() => {
  //   if (!isLoggedIn && isAllowed && ageConfirmed) {
  //     // Small delay to ensure DOM is ready
  //     setTimeout(() => {
  //       Event.emit('login_form');
  //     }, 100);
  //   }
  // }, [isLoggedIn, isAllowed, ageConfirmed]);

  if (isAllowed === null || !ageConfirmed) return null;

  if (!isLoggedIn) {
    return children; // Show the page content, login modal will overlay
  }

  return children;
};

export default ProtectedRoute;
